import { Component, signal, inject } from '@angular/core';
import { RouterOutlet, ChildrenOutletContexts } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from './core/services/language.service';
import { LoadingSpinnerComponent } from './shared/components/loading-spinner/loading-spinner.component';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
import { routeAnimations } from './core/animations';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslateModule,
    LoadingSpinnerComponent,
    ToastContainerComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
  animations: [routeAnimations]
})
export class App {
  protected readonly title = signal('merchants-front');
  private readonly languageService = inject(LanguageService);
  private readonly contexts = inject(ChildrenOutletContexts);

  protected readonly currentLanguage = this.languageService.currentLanguage;

  protected switchLanguage(): void {
    this.languageService.toggleLanguage();
  }

  protected getRouteAnimationData() {
    const context = this.contexts.getContext('primary');
    return context?.route?.snapshot?.url.join('/') || '';
  }
}
